
import { validateForm } from "./components/forms/forms";
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import { accordion } from "./aliud/ts/accordion";
import { popup } from "./components/popup/popup";
import { asideobserver } from "./components/asidebar/asideobserver";
import { responsiveBackground } from "./components/image/responsiveBackground";
import { asidebar } from "./components/asidebar/asidebar";
import { buttonUp } from "./components/buttonUp/buttonUp";
import { aliudNavigation } from "./components/navigations/aliudNavigation";
import { stickyMenu } from "./components/navigations/aliudNavigation";
import { mobileNav } from "./components/navigations/aliudNavigation";
import { responsiveCarousel } from "./components/carousel/responsiveCarousel";

document.addEventListener('DOMContentLoaded', function() {

	validateForm();
	accordion();
	asideobserver();
	asidebar();
	buttonUp();
	popup();
	aliudNavigation();
	stickyMenu();
	mobileNav();
	responsiveBackground();
	responsiveCarousel();

	var selector = '.pswp-gallery';	
	if (document.querySelector( selector )){
		console.log('selector found');
		const lightbox = new PhotoSwipeLightbox({
			gallery: selector,
			children: 'a',
			pswpModule: () => import('photoswipe')
		});
		lightbox.init();
	}
});	

